import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { Attachment } from 'tuapath-common/generated/schema';
import { attachmentFrag } from './fragments/attachmentFrag';

type Result = { addFileToPublicBox: { id: number, files: Attachment[] } };
type Variables = { file: File, userId: number, description: string, fileTypeId: number };
export const useAddFileToPublicBox = (options?: MutationHookOptions<Result, Variables>) => {
  const mutation = gql`
  ${attachmentFrag}
    mutation addFileToPublicBox($file: Upload!, $userId: Int!, $description:String, $fileTypeId: Int!) {
      addFileToPublicBox(file: $file, userId: $userId, description:$description, fileTypeId: $fileTypeId) {
        id
        files{
          ...AttachmentFrag
        }
      }
    }
  `;

  return useMutation<Result, Variables>(mutation, options);
};
export default useAddFileToPublicBox;
